const ellipsis = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M3.28 9.28a1.28 1.28 0 1 1 0-2.56 1.28 1.28 0 0 1 0 2.56m4.72 0a1.28 1.28 0 1 1 0-2.56 1.28 1.28 0 0 1 0 2.56m4.72 0a1.28 1.28 0 1 1 0-2.56 1.28 1.28 0 0 1 0 2.56"/></svg>',
};

export { ellipsis as default };
